import React, { useContext, useState, useEffect } from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import t, { mixin } from "theme"

const LightBox = ({ children, toggleComponent, ...props }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [transition, setTransition] = useState(false)

    useEffect(() => {
        if (isOpen) {
            setTransition(true)
        }
    }, [isOpen])

    return (
        <div {...props}>
            <div onClick={() => setIsOpen(true)}>{toggleComponent}</div>
            {isOpen ? (
                <Wrapper show={transition}>
                    <div
                        css={css`
                            grid-area: lbox;
                            position: relative;
                            z-index: 50001;
                            background-color: white;
                            padding: ${t.space[5]};

                            ${mixin.desktopstyle} {
                                border: 1px solid ${t.color.border};
                                border-radius: 4px;
                            }
                        `}>
                        <i
                            onClick={() => setIsOpen(false)}
                            className="icon-cross"
                            css={css`
                                cursor: pointer;
                                position: absolute;
                                right: ${t.space[3]};
                                top: ${t.space[3]};
                            `}
                        />

                        {children}
                    </div>
                </Wrapper>
            ) : null}
        </div>
    )
}

export default LightBox

const Wrapper = styled.div`
    opacity: ${({ show }) => (show ? "100" : "0")};
    ${({ show }) => (!show ? "visibility: hidden;" : "")}
    transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -webkit-transition: opacity 0.3s ease-in-out;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 50000;
    display: grid;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.7);
    overflow-x: hidden;
    grid-template-areas:
        "   .       .       .   "
        "   .       lbox    .   "
        "   .       .       .   ";

    grid-template-rows: 1fr max-content 1fr;
    grid-template-columns: minmax(0vw, calc(${t.sitewide.sideWidth} * 1.25)) 1fr minmax(
            0vw,
            calc(${t.sitewide.sideWidth} * 1.25)
        );

    ${mixin.tabletandphonestyle} {
        grid-template-rows: 5vh 90vh 5vh;
        grid-template-columns: 5vw 90vw 5vw;
    }
`
